import { FontSizes } from '@picsart/design-system/foundation/typography';

import { createUseStyles } from 'react-jss';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { BreakPointsMedia } from '@picsart/design-system/foundation/responsive';

export const usePaginationStyles = createUseStyles(
  {
    root: {
      display: 'flex',
      gap: Spacings.s12,
      listStyleType: 'none',
      margin: [0, 'auto'],
      maxWidth: '100%',
      width: 'fit-content',

      [BreakPointsMedia.SM]: {
        gap: Spacings.s6,
      },
      [BreakPointsMedia.XS]: {
        gap: Spacings.s6,
      },
      [BreakPointsMedia.XXS]: {
        gap: Spacings.s6,
      },
    },
  },
  {
    name: 'pagination',
  },
);

export const useItemStyles = createUseStyles(
  {
    circle: {
      borderRadius: CornerRadius.r24,
      fontSize: FontSizes.s14,
      fontWeight: FontWeights.semibold,
      height: Spacings.s32,
      padding: Spacings.s0,
      width: Spacings.s32,
      cursor: 'pointer',
    },

    dots: {
      margin: [Spacings.s4, Spacings.s4, Spacings.s0, Spacings.s4],
    },
  },
  { name: 'pagination-item' },
);
